// extracted by mini-css-extract-plugin
export default {"row":"pefFre7X6lbdnuT2WgDf"};